module.exports = __webpack_public_path__ + "static/img/QRCode.c548362b.svg";